const DeliveryUserInfo = ({ name, shopName }) => (
  <div className={'info'}>
    <span className={'accountName text-orange'}>{name}</span>
    <span className={'groupName'}>{shopName}</span>
  </div>
)

export default DeliveryUserInfo
